import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(public router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (sessionStorage.getItem('currentUser')) {
      let currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
      if (route.data.func && !route.data.func(currentUser.role)) {
        this.router.navigate(['/']);
        return false;
      }
      if (currentUser.isChangePasswordRequired) {
        this.router.navigate(['/change-password']);
        return false;
      }

      // logged in so return true
      /*if (window['noskip']) {
        (window['requests'] || []).forEach(r => {
          if (r.destination) r = r.destination;
          if (!r.closed && r.outerValue.url.indexOf('currentUser') < 0 && r.outerValue.url.indexOf('tenants/current') < 0) {
            r.unsubscribe();
          }
        });
      }
      window['requests'] = window['requests'] ? window['requests'].filter(r => !r.closed && (r.destination || r).outerValue.url.indexOf('projects/all') < 0 && ((r.destination || r).outerValue.url.indexOf('currentUser') >= 0 || (r.destination || r).outerValue.url.indexOf('tenants/current') >= 0)) : [];
      window['noskip'] = true;*/
      return true;
    }
    // not logged in so redirect to login page with the return url
    if (!location.pathname.startsWith('/login')) {
      this.router.navigate(['/login'], {queryParams: {returnUrl: state.url}});
    }
    return false;
  }
}
